/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { IUserConfig } from '../models/i-user-config';


@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly configBaseUrl = environment.baseUrls.api + "config"; 

  constructor(private http: HttpClient) {}

  // Save single or multiple configs
  saveConfig(config: IUserConfig | IUserConfig[]): Observable<any> {
    const url = `${this.configBaseUrl}/save`;
    return this.http.post(url, config).pipe(
      map((res: any) => res),
      catchError(this.handleError('Save Config'))
    );
  }

  // Get all configs for current user
  getAllConfigs(): Observable<IUserConfig[]> {
    const url = `${this.configBaseUrl}/all`;
    return this.http.get<IUserConfig[]>(url).pipe(
      catchError(this.handleError('Get All Configs'))
    );
  }

  // Get configs by groupId (path param)
  getConfigsByGroup(groupId: number): Observable<IUserConfig[]> {
    const url = `${this.configBaseUrl}/group/${groupId}`;
    return this.http.get<IUserConfig[]>(url).pipe(
      catchError(this.handleError('Get Configs by Group'))
    );
  }

  // Get config by name (path param)
  getConfigByName(name: string): Observable<IUserConfig> {
    const url = `${this.configBaseUrl}/name/${name}`;
    return this.http.get<IUserConfig>(url).pipe(
      catchError(this.handleError('Get Config by Name'))
    );
  }

  // Get config using query parameters
  queryConfigs(params: { groupId?: number; name?: string }): Observable<IUserConfig[]> {
    const url = `${this.configBaseUrl}`;
    let httpParams = new HttpParams();

    if (params.groupId !== undefined) {
      httpParams = httpParams.set('groupId', params.groupId.toString());
    }
    if (params.name) {
      httpParams = httpParams.set('name', params.name);
    }

    return this.http.get<IUserConfig[]>(url, { params: httpParams }).pipe(
      catchError(this.handleError('Query Configs'))
    );
  }

  // Delete config by name, id or groupId
  deleteConfig(criteria: { name?: string; id?: string; groupId?: number }): Observable<any> {
    const url = `${this.configBaseUrl}/delete`;
    return this.http
      .request('delete', url, {
        body: criteria,
      })
      .pipe(
        map((res: any) => res),
        catchError(this.handleError('Delete Config'))
      );
  }

  private handleError(operation: string) {
    return (error: any): Observable<never> => {
      console.error(`[ERROR]: ${operation} failed`, error);
      return throwError(() => new Error(`${operation} failed: ${error.message}`));
    };
  }
}
